export const DEFAULT_JOBCOST_URL = 'https://varshyl-jobcost-production.up.railway.app'

export type JobcostConfig = {
  jobcostEnabled?: boolean
  jobcostUrl?: string | null
}

export function isJobcostEnabled(config: JobcostConfig | null | undefined): boolean {
  if (import.meta.env.VITE_JOBCOST_ENABLED === 'true') return true
  return config?.jobcostEnabled === true
}

export function jobcostBaseUrl(config: JobcostConfig | null | undefined): string {
  const fromEnv = (import.meta.env.VITE_JOBCOST_URL as string | undefined)?.trim()
  if (fromEnv) return fromEnv.replace(/\/$/, '')
  if (config?.jobcostUrl) return config.jobcostUrl.replace(/\/$/, '')
  return DEFAULT_JOBCOST_URL
}

export function jobcostTruthUrl(base: string, projectId: number): string {
  return `${base.replace(/\/$/, '')}/jobcost/projects/${projectId}/profit`
}
